
import React from "react";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { RoleAvatar } from "./role-avatar";

interface ProfileAvatarProps {
  avatarUrl?: string | null;
  role: "admin" | "ouvrier";
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ 
  avatarUrl, 
  role, 
  size = "md", 
  className 
}) => {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-10 w-10", 
    lg: "h-12 w-12",
    xl: "h-16 w-16"
  };

  return (
    <Avatar className={`${sizeClasses[size]} ${className}`}>
      <AvatarImage src={avatarUrl || undefined} />
      <AvatarFallback className="p-0">
        <RoleAvatar role={role} size={size} />
      </AvatarFallback>
    </Avatar>
  );
};
